export type EstadoPedidoValue =
  | "abierto"
  | "cerrado"
  | "cancelado"
  | "borrador";

export interface EstadoPedidoOption {
  value: EstadoPedidoValue;
  label: string;
  /** Clases Tailwind para badge/chip (bg, text, border) */
  badgeClasses: string;
}

export const ESTADOS_PEDIDO: EstadoPedidoOption[] = [
  {
    value: "borrador",
    label: "Borrador",
    badgeClasses:
      "bg-slate-300 text-slate-700 border-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600",
  },
  {
    value: "abierto",
    label: "Abierto",
    badgeClasses:
      "bg-primary/20 text-primary border-primary/30 dark:bg-primary/30 dark:border-primary/50",
  },
  {
    value: "cerrado",
    label: "Cerrado",
    badgeClasses:
      // Similar al amarillo/anaranjado (#E09C2D) usado en tablas de Estadisticas.
      "bg-[#E09C2D33] text-[#E09C2D] border-[#E09C2D33] dark:bg-[#E09C2D33] dark:border-[#E09C2D33]",
  },
  {
    value: "cancelado",
    label: "Cancelado",
    badgeClasses:
      "bg-danger/20 text-danger border-danger/30 dark:bg-danger/30 dark:border-danger/50",
  },
];

export function getEstadoPedido(
  value: string
): EstadoPedidoOption | undefined {
  return ESTADOS_PEDIDO.find((e) => e.value === value);
}

export function getEstadoPedidoLabel(value: string): string {
  return getEstadoPedido(value)?.label ?? value;
}
